import Model from 'flarum/common/Model';
export default class Donation extends Model {
  name() {
    return Model.attribute('name').call(this);
  }
  amount() {
    return Model.attribute('amount').call(this);
  }
  currency() {
    return Model.attribute('currency').call(this);
  }
  message() {
    return Model.attribute('message').call(this);
  }
  donatedAt() {
    return Model.attribute('donatedAt', Model.transformDate).call(this);
  }
  isHidden() {
    return Model.attribute('isHidden').call(this);
  }
  createdAt() {
    return Model.attribute('createdAt', Model.transformDate).call(this);
  }
}
flarum.reg.add('neverhack-forum-nodes', 'common/models/Donation', Donation);